class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');
    this.predictiveTrends = this.querySelector('#predictive-trends');
    this.clearButton = this.querySelector('.search-clear-button');

    this.input.addEventListener(
      'input',
      this.debounce((event) => {
        this.onChange(event);
        this.updateClearButtonVisibility();
      }, 300).bind(this),
    );

    // Show default trends when user focuses on search input
    this.input.addEventListener('focus', () => {
      this.updateClearButtonVisibility();
      if (!this.input.value.trim()) {
        this.showTrends();
      }
    });

    // Also show trends on click
    this.input.addEventListener('click', () => {
      if (!this.input.value.trim()) {
        this.showTrends();
      }
    });

    // Hide clear button when input loses focus (unless it has content)
    this.input.addEventListener('blur', () => {
      setTimeout(() => {
        this.updateClearButtonVisibility();
      }, 100); // Small delay to allow clear button click to register
    });

    // Clear button functionality
    if (this.clearButton) {
      this.clearButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.clearSearch();
      });
    }

    // Hide search results when clicking outside
    document.addEventListener('click', (event) => {
      if (!this.contains(event.target)) {
        this.close();
      }
    });
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.showTrends();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    const q = encodeURIComponent(searchTerm);
    fetch(
      `/search/suggest?q=${q}&resources[type]=product,collection,article&resources[options][fields]=title,variants.title,variants.sku&section_id=predictive-search`,
    )
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.showSearchResults();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  showTrends() {
    // Hide search results and show trends
    this.predictiveSearchResults.style.display = 'none';
    this.predictiveTrends.style.display = 'block';
    this.input.style.borderRadius = '24px 24px 0 0';
  }

  showSearchResults() {
    // Hide trends and show search results
    this.predictiveTrends.style.display = 'none';
    this.predictiveSearchResults.style.display = 'block';
    this.input.style.borderRadius = '24px 24px 0 0';
  }

  close() {
    // Hide both trends and search results
    this.predictiveSearchResults.style.display = 'none';
    this.predictiveTrends.style.display = 'none';
    this.input.style.borderRadius = '24px';
    this.updateClearButtonVisibility();
  }

  clearSearch() {
    this.input.value = '';
    this.close();
    this.updateClearButtonVisibility();
  }

  updateClearButtonVisibility() {
    if (!this.clearButton) return;

    const hasContent = this.input.value.trim().length > 0;
    const hasFocus = document.activeElement === this.input;

    // Show clear button if input has content OR if input is focused
    if (hasContent || hasFocus) {
      this.clearButton.style.display = 'block';
    } else {
      this.clearButton.style.display = 'none';
    }
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
customElements.define('predictive-search', PredictiveSearch);
